export function escapeSpecialChar(value: string): string {
  return value.replace(/\r?\n/g, '').replace(',', '');
}

// アンケート用の新しい関数を追加
export function formatCsvText(value: string): string {
  if (!value) return '';
  
  const processedValue = value.replace(/\r?\n/g, ' / ');
  
  if (processedValue.includes(',') || processedValue.includes('"')) {
    return `"${processedValue.replace(/"/g, '""')}"`;
  }
  return processedValue;
}

export function formatXlsxText(value: string): string {
  return value || '';
}
